export default "__VITE_ASSET__BYkX1pTq__"